import { useEffect } from "react";
import TabsNoContent from "../Tabs/TabsNoContent";
import styles from "../RightSidebar/rightsidebar.module.css";
import { useGlobalContext } from "../../Context/GlobalContext";

const SourceSelector = ({
	setSourceSelected,
	error,
	setError,
	fromEdit = false,
}) => {
	const { 
		editableBooking,
		setItemData, 
		setEditedItemData, 
		setSelectedSource, 
		selectedSource
	 } = useGlobalContext();
	const sourceOptions = [
		{ label: "WhatsApp", value: "WhatsApp" },
		{ label: "Walk-in", value: "Walk-in" },
		{ label: "By Phone", value: "By Phone" },
	];
	const handleSourceSelect = (selected) => {
		// Support both tab selection (string) and dropdown object shape
		const value = typeof selected === "string" ? selected : selected.value;
		setSelectedSource(value);
		if (!fromEdit && typeof setSourceSelected === "function") {
			setSourceSelected(true);
		}
		setItemData((prev) => ({
			...prev,
			source: value,
		}));
		if (fromEdit) {
			setEditedItemData((prev) => ({
				...prev,
				source: value,
			}));
		}
		if (!fromEdit && typeof setError === "function") {
			setError("");
		}
	};

	useEffect(() => {
		if (editableBooking?.source) {
			setSelectedSource(editableBooking?.source);
			if (!fromEdit && typeof setSourceSelected === "function") {
				setSourceSelected(true);
			}
		}
	}, [editableBooking?.source, setSelectedSource, fromEdit, setSourceSelected]);

	useEffect(() => {
		if (!editableBooking?.source && !selectedSource) {
			handleSourceSelect("WhatsApp");
		}
	}, []);
	return (
		<>
			<div className={`${styles.SourceSelector} ${styles.sourceTabs}`}>
				<p className={styles.sourceTabsHeading}>Select source</p>
				<TabsNoContent
					tabs={sourceOptions.map((o) => ({ label: o.label, eventKey: o.value }))}
					defaultActiveKey={editableBooking?.source || "WhatsApp"}
					onSelect={(eventKey) => handleSourceSelect(eventKey)}
				/>
			</div>
			{error && <p className={styles.errorMessage}>{error}</p>}
		</>
	);
};

export default SourceSelector;
